import {
	Component, ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output, ViewChild,
	ViewEncapsulation
} from '@angular/core';
declare let d3;

import { SpeakerService } from '../speaker.service';
import ErrorBarsPlugin from 'chartjs-plugin-error-bars';

@Component({
	selector: 'bar-chart',
	templateUrl: 'bar-chart.component.html',
	styleUrls: ['bar-chart.component.css'],
	encapsulation: ViewEncapsulation.None
})

export class BarChartComponent implements OnInit {
	@ViewChild('bar') bar: ElementRef;
	@Input() category = 'social class';
	@Output() onChartClick = new EventEmitter();

	// PLOT DATA VARIABLE
	plotData;

	colors = ['#4f94cd', '#eeaeee', '#f4a460', '#b3ee3a', '#ee7600', '#2e8b57'];

	// DATA OPTIONS
	options = {
		legend: {
			onClick: (e) => e.stopPropagation()
		},
		plugins: {
			chartJsPluginErrorBars: {
				color: 'rgba(0, 0, 0, 0.1)',
				width: '5%'
			}
		},
		plugin: [ErrorBarsPlugin],
		scales: {
			yAxes: [
				{
					ticks: {
						min: 0,
						max: 0,
						beginAtZero: true
					},
					scaleLabel: {
						display: true,
						labelString: 'Relative Frequency per 10,000'
					}
				}
			]
		},
		tooltips: {
			enabled: true,
			mode: 'single',
			displayColors: false,
			callbacks: {
				label: function (tooltipItem, data) {
					let datasetLabel = Number(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
					let count = Number(data.datasets[tooltipItem.datasetIndex].counts[tooltipItem.index]);
					if (datasetLabel != 0) {
						let i = 2;
						while (Number(d3.format(',.0' + i + 'f')(datasetLabel).replace(",", "")) == 0) {
							i++;
						}
						return d3.format(',.0' + i + 'f')(datasetLabel) + " (" + count + ")";
					}
					return d3.format(',.02f')(datasetLabel) + " (" + count + ")";
				}
			}
		}
	};


	regionKeys = ['London', 'Midlands', 'North England', 'Republic of Ireland', 'Scotland',
		'Southeast', 'Southwest', 'Wales', 'Northern Ireland'];

	genderKeys = ['m', 'f'];

	socialKeys = ['working class', 'middle class', 'student', 'retired', 'unknown'];

	public barChartOptions: any = {
		scaleShowVerticalLines: false,
		responsive: true
	};

	public barChartLabels: string[] = [];
	public barChartType: string = 'bar';
	public barChartLegend: boolean = true;
	public barColors: any[];

	constructor(private speakerSrv: SpeakerService) { }

	getStandardDeviation(array) {
		const n = array.length

		if (n == 0)
			return 0;

		const mean = array.reduce((a, b) => a + b) / n
		return Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n ** 2)
	}

	ngOnInit(): void {
		this.speakerSrv.statsChange.subscribe(stats => { this.update(stats); });
		this.barColors = [];
		let ctx = this.bar.nativeElement.getContext('2d');
		let grad1 = ctx.createLinearGradient(0, 0, 0, 200);
		grad1.addColorStop(0, 'rgb(105,130,231)');
		grad1.addColorStop(1, 'rgb(125,222,238)');

		let grad2 = ctx.createLinearGradient(0, 0, 0, 200);
		grad2.addColorStop(0, 'rgb(233,105,210)');
		grad2.addColorStop(1, 'rgb(247,126,151)');

		this.barColors.push({ backgroundColor: grad1, hoverBackgroundColor: grad1 });
		this.barColors.push({ backgroundColor: grad2, hoverBackgroundColor: grad2 });
	}

	roundUp(value) {
		let multiplier = Math.pow(10, Math.floor(Math.log10(value)));
		return Math.ceil(value / multiplier) * multiplier;
	}

	update(stats) {
		let data = { labels: ['1994', '2014'] };
		// If array is not empty
		if (Object.keys(stats).length > 0) {
			//Set Keys to the chart type
			let keys;
			switch (this.category) {
				case "gender":
					keys = this.genderKeys;
					this.barChartLabels = this.genderKeys;
					break;
				case "area":
					keys = this.regionKeys;
					this.barChartLabels = this.regionKeys;
					break;
				case "social class":
					keys = this.socialKeys;
					this.barChartLabels = this.socialKeys;
					break;
				default:
					keys = [];
					break;
			}

			// Create an object that has the total value of all the keys added together
			var obj = keys.reduce(function (acc, cur, i) {
				acc[cur] = 0;
				return acc;
			}, {});

			// Assign Corpus Total Dictionary to categorise data.
			let corpusTotal = { '1994': Object.assign({}, obj), '2014': Object.assign({}, obj) };
			let countTotal = { '1994': Object.assign({}, obj), '2014': Object.assign({}, obj) };
			let absoluteTotal = { '1994': Object.assign({}, obj), '2014': Object.assign({}, obj) };

			var obj1 = keys.reduce(function (acc, cur, i) {
				acc[cur] = [];
				return acc;
			}, {});
			var obj2 = keys.reduce(function (acc, cur, i) {
				acc[cur] = [];
				return acc;
			}, {});

			let deviations = { '1994': Object.assign({}, obj1), '2014': Object.assign({}, obj2) };

			// For each data label (1994, 2014)
			for (let i = data.labels.length - 1; i >= 0; i--) {
				// Assign Label to L
				let l = data.labels[i];
				// Create an object for each dataset
				const objKeys = Object.keys(stats[l])
				// Add data to the corpus total
				for (let j = objKeys.length - 1; j >= 0; j--) {
					// Get stats on one person
					let g = stats[l][objKeys[j]];
					//     console.log(g);
					//     console.log('CAT'+g[this.category]);

					// Add relative frequency to total
					if (g['relative'] == null) {
						//       console.log("NULL")
					} else {
						absoluteTotal[l][g[this.category]] += g['count'];
						corpusTotal[l][g[this.category]] += g['relative'];
						deviations[l][g[this.category]].push(g['relative']);
						countTotal[l][g[this.category]] += 1;
						//         console.log('REL'+g['relative']);
					}

				}
			}

			//   console.log(corpusTotal['1994']);

			//    const keys94 = Object.keys(corpusTotal['1994']).sort();
			//    const values94 = Object.keys(corpusTotal['1994']).map(key=>corpusTotal['1994'][key]);
			//    console.log(values94);
			//     const keys14 = Object.keys(corpusTotal['2014']).sort();
			//    const values14 = Object.keys(corpusTotal['2014']).map(key=>corpusTotal['2014'][key]);

			const values94 = this.generateDataArray(countTotal['1994'], corpusTotal['1994'], this.socialKeys);
			const values14 = this.generateDataArray(countTotal['2014'], corpusTotal['2014'], this.socialKeys);

			const counts94 = this.generateCountArray(countTotal['1994'], absoluteTotal['1994'], this.socialKeys);
			const counts14 = this.generateCountArray(countTotal['2014'], absoluteTotal['2014'], this.socialKeys);

			this.plotData = [
				{
					errorBars: [],
					label: '1994',
					counts: counts94,
					data: values94//,
					//   backgroundColor: ["#c47eee", "#e86dd0"]//"rgb(31, 119, 180)"
				},
				{
					errorBars: [],
					label: '2014',
					counts: counts14,
					data: values14//,
					//    backgroundColor: ["#d3f77f", "#eac26c"]//"rgb(255, 127, 14)"
				}
			];

			for (let i = 0; i < this.socialKeys.length; i++) {
				let standard_deviation = this.getStandardDeviation(deviations['1994'][this.socialKeys[i]]);
				this.plotData[0].errorBars[this.socialKeys[i]] = { plus: standard_deviation, minus: -standard_deviation }

				let value = this.plotData[0].data[i]

				let max_value = this.roundUp(value + standard_deviation)

				if (max_value > this.options.scales.yAxes[0].ticks.max)
					this.options.scales.yAxes[0].ticks.max = max_value;

				standard_deviation = this.getStandardDeviation(deviations['2014'][this.socialKeys[i]]);
				this.plotData[1].errorBars[this.socialKeys[i]] = { plus: standard_deviation, minus: -standard_deviation }

				value = this.plotData[1].data[i]

				max_value = this.roundUp(value + standard_deviation)

				if (max_value > this.options.scales.yAxes[0].ticks.max)
					this.options.scales.yAxes[0].ticks.max = max_value;
			}
		}
	}
	//['#4f94cd', '#eeaeee', '#f4a460', '#b3ee3a', '#ee7600', '#2e8b57'];

	// GET CATEGORY
	onDataSelect(event) {
		this.onChartClick.emit({ src: 'CHART-' + this.category, event: event });
	}

	generateDataArray(counts, corpus, keys) {
		let arr = [];
		for (let i = 0; i < keys.length; i++) {
			arr.push(corpus[keys[i]] / counts[keys[i]]);
		}
		return arr;
	}

	generateCountArray(counts, corpus, keys) {
		let arr = [];
		for (let i = 0; i < keys.length; i++) {
			arr.push(corpus[keys[i]]);
		}
		return arr;
	}

	public chartClicked(event: any) {

		console.log(event);
		if (event.active.length > 0) {
			let chartElement = event.active[0]._chart.getElementAtEvent(event.event);
			console.log(chartElement[0]._model.datasetLabel);
			let newEvent = {
				element: {
					_model: {
						datasetLabel: chartElement[0]._model.datasetLabel,
						label: chartElement[0]._model.label
					}
				}
			};
			this.speakerSrv.changeView('Concordance', event);
			this.speakerSrv.concordanceClassFilter.next(newEvent);
		}
		//  this.speakerSrv.changeView('Concordance', $event);
		// this.speakerSrv.concordanceProficiencyFilter.next($event);
	}
}





// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/bar-chart/bar-chart.component.ts